/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */
import { CURRENT_CLIENT_TEMPLATE_VAR } from '@core';
import { HttpClient } from '@angular/common/http';

import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import type {
  UpdateWorkflowDto,
  WorkflowsControllerCreateWorkflowV1201,
  WorkflowsControllerCreateWorkflowV1Body,
  WorkflowsControllerCreateWorkflowV1PathParameters,
  WorkflowsControllerDeleteWorkflowV1PathParameters,
  WorkflowsControllerExceedWorkflowV1200,
  WorkflowsControllerExceedWorkflowV1PathParameters,
  WorkflowsControllerGetWorkflowV1200,
  WorkflowsControllerGetWorkflowV1PathParameters,
  WorkflowsControllerGetWorkflowsV1200,
  WorkflowsControllerGetWorkflowsV1PathParameters,
  WorkflowsControllerUpdateWorkflowV1200,
  WorkflowsControllerUpdateWorkflowV1PathParameters,
} from '../models';

@Injectable({ providedIn: 'root' })
export class WorkflowsService {
  private readonly http = inject(HttpClient);
  /**
   * @summary Retrieve all workflows for a client and device
   */

  getWorkflows<TData = WorkflowsControllerGetWorkflowsV1200>({
    clientId = CURRENT_CLIENT_TEMPLATE_VAR,
    deviceId,
  }: WorkflowsControllerGetWorkflowsV1PathParameters): Observable<TData> {
    return this.http.get<TData>(`/devices/v1/clients/${clientId}/devices/${deviceId}/workflows`);
  }
  /**
   * @summary Create a new workflow
   */

  createWorkflow<TData = WorkflowsControllerCreateWorkflowV1201>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR, deviceId }: WorkflowsControllerCreateWorkflowV1PathParameters,
    workflowsControllerCreateWorkflowV1Body: WorkflowsControllerCreateWorkflowV1Body,
  ): Observable<TData> {
    return this.http.post<TData>(`/devices/v1/clients/${clientId}/devices/${deviceId}/workflows`, workflowsControllerCreateWorkflowV1Body);
  }
  /**
   * @summary Retrieve a specific workflow
   */

  getWorkflow<TData = WorkflowsControllerGetWorkflowV1200>({
    clientId = CURRENT_CLIENT_TEMPLATE_VAR,
    deviceId,
    id,
  }: WorkflowsControllerGetWorkflowV1PathParameters): Observable<TData> {
    return this.http.get<TData>(`/devices/v1/clients/${clientId}/devices/${deviceId}/workflows/${id}`);
  }
  /**
   * @summary Update a workflow
   */

  updateWorkflow<TData = WorkflowsControllerUpdateWorkflowV1200>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR, deviceId, id }: WorkflowsControllerUpdateWorkflowV1PathParameters,
    updateWorkflowDto: UpdateWorkflowDto,
  ): Observable<TData> {
    return this.http.patch<TData>(`/devices/v1/clients/${clientId}/devices/${deviceId}/workflows/${id}`, updateWorkflowDto);
  }
  /**
   * @summary Delete a workflow
   */

  deleteWorkflow<TData = void>({
    clientId = CURRENT_CLIENT_TEMPLATE_VAR,
    deviceId,
    id,
  }: WorkflowsControllerDeleteWorkflowV1PathParameters): Observable<TData> {
    return this.http.delete<TData>(`/devices/v1/clients/${clientId}/devices/${deviceId}/workflows/${id}`);
  }
  /**
   * @summary Exceed a workflow
   */

  exceedWorkflow<TData = WorkflowsControllerExceedWorkflowV1200>({
    clientId = CURRENT_CLIENT_TEMPLATE_VAR,
    deviceId,
    id,
  }: WorkflowsControllerExceedWorkflowV1PathParameters): Observable<TData> {
    return this.http.post<TData>(`/devices/v1/clients/${clientId}/devices/${deviceId}/workflows/${id}/exceed`, undefined);
  }
}
